import { Button } from "@material-ui/core";
import React from "react";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

export function ScrollToBottomButton({
  missedGroupMessages = 0,
  scrollToBottom = () => null,
  chatTemplate,
}) {
  const { primaryColor, secondaryColor } = chatTemplate;
  return (
    <Button
      onClick={scrollToBottom}
      style={{ color: secondaryColor, backgroundColor: primaryColor }}
      className="scroll-to-bottom-button"
      startIcon={<ArrowDownwardIcon />}
    >
      {missedGroupMessages > 0 ? (
        <span>
          {missedGroupMessages} {"  "} <SystemLabel name="UndreadMessages" />{" "}
        </span>
      ) : (
        <SystemLabel name="ToBottom" />
      )}
    </Button>
  );
}
